export default "__VITE_ASSET__fe82ae39__"